module.exports = __webpack_public_path__ + "img/ercode.896e284b.png";